/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * notifications
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Get notifications
 */
export const getNotifications200ResponseDataItemsItemSendTypeMax = 100;

export const getNotifications200ResponseDataItemsItemNotificationTitleThMax = 100;

export const getNotifications200ResponseDataItemsItemNotificationTitleEnMax = 100;

export const getNotifications200ResponseDataItemsItemNotificationTitleJaMax = 100;

export const getNotifications200ResponseDataItemsItemNotificationBodyThMax = 100;

export const getNotifications200ResponseDataItemsItemNotificationBodyEnMax = 100;

export const getNotifications200ResponseDataItemsItemNotificationBodyJaMax = 100;

export const getNotifications200ResponseDataItemsItemLinkUrlMax = 500;

export const GetNotifications200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                items: zod
                    .array(
                        zod
                            .object({
                                notification_id: zod.number().optional(),
                                user_id: zod.number().optional(),
                                actor_user_id: zod.number().nullish(),
                                notification_config_id: zod.number().nullish(),
                                send_type: zod
                                    .string()
                                    .max(getNotifications200ResponseDataItemsItemSendTypeMax)
                                    .optional(),
                                notification_title_th: zod
                                    .string()
                                    .max(getNotifications200ResponseDataItemsItemNotificationTitleThMax)
                                    .optional(),
                                notification_title_en: zod
                                    .string()
                                    .max(getNotifications200ResponseDataItemsItemNotificationTitleEnMax)
                                    .optional(),
                                notification_title_ja: zod
                                    .string()
                                    .max(getNotifications200ResponseDataItemsItemNotificationTitleJaMax)
                                    .optional(),
                                notification_body_th: zod
                                    .string()
                                    .max(getNotifications200ResponseDataItemsItemNotificationBodyThMax)
                                    .optional(),
                                notification_body_en: zod
                                    .string()
                                    .max(getNotifications200ResponseDataItemsItemNotificationBodyEnMax)
                                    .optional(),
                                notification_body_ja: zod
                                    .string()
                                    .max(getNotifications200ResponseDataItemsItemNotificationBodyJaMax)
                                    .optional(),
                                link_url: zod
                                    .string()
                                    .max(getNotifications200ResponseDataItemsItemLinkUrlMax)
                                    .optional(),
                                data_json: zod
                                    .union([zod.record(zod.string(), zod.unknown()), zod.array(zod.unknown())])
                                    .optional(),
                                read_at: zod.string().datetime({ offset: true }).nullish(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict(),
                    )
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetNotifications401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

/**
 * @summary Get unread count
 */
export const GetUnreadCount200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                unread_count: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetUnreadCount401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

/**
 * @summary Mark notification as read
 */
export const MarkNotificationAsReadParams = zod
    .object({
        notification_id: zod.number(),
    })
    .strict();

export const MarkNotificationAsRead200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                notification_id: zod.number().optional(),
                read: zod.union([zod.literal(0), zod.literal(1)]).optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const MarkNotificationAsRead401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

/**
 * @summary Mark all notifications as read
 */
export const MarkAllNotificationsAsRead200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                updated_count: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const MarkAllNotificationsAsRead401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();
